export default __webpack_public_path__ + "static/media/Quarto-LightItalic.ac3dd3b1.woff2";